import type { EventListItem } from "../../types";
import { useEdition } from "../../hooks/useEdition";
import { getImageUrl } from "../../lib/image";
import { getLocalizedName } from "../../lib/localization";
import { ImageWithSkeleton } from "../ui/ImageWithSkeleton";

type EventCardProps = {
  event: EventListItem;
  onClick: () => void;
};

const CalendarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
    <line x1="16" x2="16" y1="2" y2="6" />
    <line x1="8" x2="8" y1="2" y2="6" />
    <line x1="3" x2="21" y1="10" y2="10" />
  </svg>
);

export function EventCard({ event, onClick }: EventCardProps) {
  const { locale, edition } = useEdition();
  const fallback = edition?.default_locale_code;
  const eventName = getLocalizedName(event, locale, fallback) ?? "";
  const imageUrl = getImageUrl(event.image, "medium");
  const categories = event.categories.slice(0, 2);

  return (
    <button
      type="button"
      className="festapp-artist-card"
      data-item-id={event._id}
      onClick={onClick}
    >
      <div className="festapp-artist-card-image">
        <ImageWithSkeleton
          src={imageUrl}
          alt={eventName}
          fallbackIcon={CalendarIcon}
        />
      </div>
      <div className="festapp-artist-card-content">
        <h3 className="festapp-artist-card-name">{eventName}</h3>
        {categories.length > 0 ? (
          <p className="festapp-artist-card-categories">
            {categories
              .map((cat) => getLocalizedName(cat, locale, fallback))
              .filter(Boolean)
              .join(", ")}
          </p>
        ) : (
          <p className="festapp-artist-card-categories">&nbsp;</p>
        )}
      </div>
    </button>
  );
}
